import Vue from 'vue';
import autofocus from './autofocus';

Vue.directive('autofocus', autofocus);
